import { TenantStatisticsViewModel, TenantViewModel } from '@ail/customers-api'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { Arr } from '../../../../helpers/Arr'
import { FrontendSettings } from '../../../../helpers/FrontendSettings'
import { useAuth } from '../../../../hooks/useAuth'
import { FrontendSettingsKeys } from '../../../../types/enums'
interface Props {
  tenant: TenantViewModel
  stats?: TenantStatisticsViewModel
  onCopy: (id: string) => void
  onDelete: (tenant: TenantViewModel) => void
}
export function TenantCard({ tenant, onCopy, onDelete, stats }: Props) {
  const { user } = useAuth()

  const { t } = useTranslation('common')
  const history = useHistory()

  const getTenantTypeIcon = (tenant: TenantViewModel) => {
    if (tenant.isCompany) {
      return 'customers'
    }
    if (tenant.isInsurance) {
      return 'liability'
    }
    if (tenant.isSupplier) {
      return 'supplier'
    }
  }

  const moveToGroupEdit = (id: string) => {
    history.push(`/UserManagement/groups/group/edit/${id}`)
  }

  const moveToAssignToGroup = (id: string) => {
    FrontendSettings.set(FrontendSettingsKeys.preselectedTenantId, id)
    history.push(`/UserManagement/groups/assignToGroup/${id}`)
  }

  const moveToCompaniesGrid = (id: string) => {
    FrontendSettings.set(FrontendSettingsKeys.preselectedTenantId, id)
    history.push('/UserManagement/companies')
  }

  const moveToUsersGrid = (id: string) => {
    FrontendSettings.set(FrontendSettingsKeys.preselectedTenantId, id)
    history.push('/UserManagement/users')
  }

  return (
    <div key={tenant.id} className="col-6 col-md-3">
      <div className="box groupArea">
        <div className="itemTitle">
          <span>{tenant.name}</span>
          <div style={{ display: 'flex', gap: '10px' }}>
            {!!getTenantTypeIcon(tenant) && (
              <div className="tenantType">
                <i className={`icon-${getTenantTypeIcon(tenant)}`} style={{ margin: '0px' }} />
              </div>
            )}
            <button onClick={() => onCopy(tenant.id)} className="delete">
              <i className="icon-id" style={{ margin: '0px' }} />
            </button>
            {user?.isAdmin && (
              <button onClick={() => onDelete(tenant)} className="delete">
                <i className="icon-clear"></i>
                {t('DELETE')}
              </button>
            )}
          </div>
        </div>
        <div className="flex">
          <div className="itemAction">
            <div className="action" onClick={() => moveToCompaniesGrid(tenant.id)}>
              <div className="table-cell">
                <i className="icon-customers"></i>
                {t('COMPANIES')}
              </div>
              <span className="numb">{stats?.customersCount}</span>
            </div>
          </div>
          <div className="itemAction">
            <div className="action" onClick={() => moveToUsersGrid(tenant.id)}>
              <div className="table-cell">
                <i className="icon-users"></i>
                {t('USERS')}
              </div>
              <div className="numbContainer">
                {!!stats?.activeUsers && (
                  <span className="numb active">
                    <i className="icon-users" />
                    {stats.activeUsers}
                  </span>
                )}
                {!!stats?.inactiveUsers && (
                  <span className="numb inactive">
                    <i className="icon-users" />
                    {stats.inactiveUsers}
                  </span>
                )}
              </div>
            </div>
          </div>
          {user?.isAdmin && (
            <div className="itemAction">
              <div className="action" onClick={() => moveToGroupEdit(tenant.id)}>
                <div className="table-cell">
                  <i className="icon-edit"></i>
                  {t('EDIT')}
                </div>
              </div>
            </div>
          )}
          {(user?.isAdmin || (user?.isInternalUser && user?.isManager)) && (
            <div className="itemAction">
              <div className="action" onClick={() => moveToAssignToGroup(tenant.id)}>
                <div className="table-cell">
                  <i className="icon-assign"></i>
                  {t('ASSIGN_TO_TENANT')}
                </div>
              </div>
            </div>
          )}
        </div>
        {Arr.any(tenant.tags) && (
          <div className="tagsSection">
            <i className="icon-tag" />
            <div> {tenant.tags.join(', ')} </div>
          </div>
        )}
      </div>
    </div>
  )
}
